var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content mt-20"},[_c('smart-table',{attrs:{"table-label":_vm.labels,"table-data":_vm.searchData.list,"table-opt":_vm.opt}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-right mt-20"},[_c('pagination',{attrs:{"page":_vm.searchParams.page,"pages":_vm.searchData},on:{"on-search":_vm.toPage}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0ad110e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/ExchangeList.vue
// module id = null
// module chunks = 